
import { useState, useEffect } from 'react';

interface StickyWhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  label?: string;
}

export default function StickyWhatsAppButton({
  phoneNumber = '819092895522',
  message = 'こんにちは！ドライビングアシスタントサービスについてお問い合わせしたいです。%0A%0A【ご希望日】%0A【ご利用時間】%0A【人数】%0A%0Aよろしくお願いいたします。',
  label = 'WhatsAppで予約'
}: StickyWhatsAppButtonProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (footerRect.top < windowHeight) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed left-4 bottom-4 z-40 transition-all duration-300 lg:hidden ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
      style={{ cursor: 'pointer' }}
    >
      <div className="bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white px-5 py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2.5 whitespace-nowrap hover:scale-105">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl"></i>
        </div>
        <span className="font-semibold text-sm tracking-wide">{label}</span>
      </div>
    </a>
  );
}
